import { RefObject, useEffect, useRef } from "react"

// Ferme un panneau flottant au clic en dehors de `ref`. Le callback est stocké en ref pour attacher
// l'écouteur une seule fois (pas de ré-abonnement à chaque rendu).
export function useClickOutside<T extends HTMLElement>(ref: RefObject<T | null>, onOutside: () => void, enabled = true) {
    const callbackRef = useRef(onOutside)
    callbackRef.current = onOutside

    useEffect(() => {
        if (!enabled) {
            return
        }
        const handler = (event: MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                callbackRef.current()
            }
        }
        document.addEventListener("mousedown", handler)
        return () => document.removeEventListener("mousedown", handler)
    }, [ref, enabled])
}
